import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Content from "./Content";
import { Gallery } from "react-grid-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";

// Image imports
import autumn from "../images/autumn.jpg";
import bluebells from "../images/bluebells.jpg";
import losehill from "../images/losehill.jpg";
import winter_scene from "../images/winter_scene.jpg";
import cottage_garden from "../images/cottage_garden.jpg";
import autumn_fields from "../images/autumn_fields.jpg";
import daffodils from "../images/daffodils.jpg";
import daisies from "../images/daisies.jpg";
import derbyshire_landscape from "../images/derbyshire_landscape.jpg";
import fading_light from "../images/fading_light.jpg";
import shades_of_autumn from "../images/shades_of_autumn.jpg";
import snowdrops from "../images/snowdrops.jpg";
import summer_day from "../images/summer_day.jpg";
import wildflower_bay from "../images/wildflower_bay.jpg";
import winter_blues from "../images/winter_blues.jpg";
import fuchsias from "../images/fuchsias.jpg";
import orange_vase from "../images/orange_vase.jpg";
import seedhead_sunset from "../images/seedhead_sunset.jpg";
import seedheads from "../images/seedheads.jpg";
import peak_poppies from "../images/peak_poppies.jpg";
import pinks_and_blues from "../images/pinks_blues.jpg";
import seashore from "../images/seashore.jpg";
import hope_valley from "../images/hope_valley.jpg";
import moorland_heather from "../images/moorland_heather.jpg";
import summer_meadow from "../images/summer_meadow.jpeg";
import oranges_and_pinks from "../images/oranges_and_pinks.jpeg";
import blues_and_gold from "../images/blues_and_gold.jpeg";
import autumn_in_the_peak from "../images/autumn_in_the_peak.jpeg";
import poppies from "../images/poppies.jpg";
import crocus from "../images/crocus.jpg";
import spring_in_the_peak from "../images/spring_in_the_peak.jpg";
import purple_haze from "../images/purple_haze.jpeg";
import seeds_and_stems from "../images/seeds_and_stems.jpeg";
import summer_daisies from "../images/summer_daisies.png";
import autumn_interest from "../images/autumn_interest.jpg";


const photos = [
  {
    src: losehill,
    index: 0,
    caption: "Losehill"
  },
  {
    src: cottage_garden,
    index: 1,
    caption: "Cottage garden"
  },
  {
    src: bluebells,
    index: 2,
    caption: "Bluebells"
  },
  {
    src: autumn_fields,
    index: 3,
    caption: "Autumn fields"
  },
  {
    src: moorland_heather,
    index: 4,
    caption: "Moorland Heather"
  },
  {
    src: hope_valley,
    index: 5,
    caption: "Hope Valley"
  },
  {
    src: seashore,
    index: 6,
    caption: "Seashore"
  },
  {
    src: pinks_and_blues,
    index: 7,
    caption: "Pinks and Blues"
  },
  {
    src: peak_poppies,
    index: 8,
    caption: "Peak Poppies"
  },
  {
    src: seedheads,
    index: 9,
    caption: "Seedheads"
  },
  {
    src: seedhead_sunset,
    index: 10,
    caption: "Seedhead sunset"
  },
  { src: orange_vase, index: 11, caption: "Orange vase" },
  { src: fuchsias, index: 12, caption: "Fuchsias" },
  {
    src: winter_blues,
    index: 13,
    caption: "Winter blues"
  },
  {
    src: wildflower_bay,
    index: 14,
    caption: "Wildflower bay"
  },
  {
    src: summer_day,
    index: 15,
    caption: "Summer day"
  },
  {
    src: snowdrops,
    index: 16,
    caption: "Snowdrops"
  },
  {
    src: shades_of_autumn,
    index: 17,
    caption: "Shades of autumn"
  },
  {
    src: fading_light,
    index: 18,
    caption: "Fading light"
  },
  {
    src: derbyshire_landscape,
    index: 19,
    caption: "Derbyshire landscape"
  },
  {
    src: daisies,
    index: 20,
    caption: "Daisies"
  },
  {
    src: daffodils,
    index: 21,
    caption: "Daffodils"
  },
  {
    src: autumn,
    index: 22,
    caption: "Autumn"
  },
  {
    src: autumn_in_the_peak,
    index: 23,
    caption: "Autumn in the peak"
  },
  {
    src: blues_and_gold,
    index: 24,
    caption: "Blues and gold"
  },
  {
    src: oranges_and_pinks,
    index: 25,
    caption: "Oranges and pinks"
  },
  {
    src: summer_meadow,
    index: 26,
    caption: "Summer meadow"
  },
  {
    src: winter_scene, 
    index: 27, 
    caption: "Winter scene"
  },
  {
    src: poppies,
    index: 28,
    caption: "Poppies"
  },
  {
    src: crocus,
    index: 29,
    caption: "Crocus"
  },
  {
    src: spring_in_the_peak,
    index: 30,
    caption: "Spring in the Peak"
  },
  {
    src: purple_haze,
    index: 31,
    caption: "Purple Haze"
  },
  {
    src: seeds_and_stems,
    index: 32,
    caption: "Seeds and Stems"
  },
  {
    src: summer_daisies,
    index: 33,
    caption: "Summer Daisies"
  },
  {
    src: autumn_interest,
    index: 34,
    caption: "Autumn interest"
  }
];

const landscapePhotos = photos.filter(photo => {
  const landscapeKeywords = ["losehill", "moorland_heather", "hope_valley", "seashore", "derbyshire_landscape", "summer_meadow", "winter_scene", "spring_in_the_peak", "peak_poppies", "wildflower_bay", "autumn_in_the_peak"];
  return landscapeKeywords.some(keyword => photo.src.includes(keyword));
});

const floraPhotos = photos.filter(photo => {
  const floraKeywords = ["cottage_garden", "bluebells", "pinks_and_blues", "seedheads", "orange_vase", "fuchsias", "snowdrops", "daisies", "daffodils", "poppies", "crocus", "shades_of_autumn", "autumn_fields", "seedhead_sunset", "winter_blues", "fading_light", "autumn", "blues_and_gold", "oranges_and_pinks", "summer_day", "seeds_and_stems", "summer_daisies", "purple_haze", "autumn_interest"];
  // Ensure it's not also a landscape if names are ambiguous, though current keywords are fairly distinct
  return floraKeywords.some(keyword => photo.src.includes(keyword)) && !landscapePhotos.includes(photo);
});


const Works = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <div>
      <Content>
        <h2>Examples of my work</h2>
        <p>
          These are just a few examples to illustrate the kind of work I do. You
          can{" "}
          <Link to={"https://www.instagram.com/kath_priestley_designs/"}>
            see my latest projects on Instagram
          </Link>
          .
        </p>
        <p>
          If you're interested in seeing the original pieces I currently have
          for sale, you can{" "}
          <Link to={"https://www.etsy.com/shop/KathPriestleyDesigns"}>
            find them on my Etsy shop.
          </Link>
        </p>
        <p>Click on an image to see it in more detail.</p>
        
        <h3>Landscapes</h3>
        <Gallery
          images={landscapePhotos}
          onClick={openLightbox}
          enableImageSelection={false}
        />

        <h3>Flora</h3>
        <Gallery
          images={floraPhotos}
          onClick={openLightbox}
          enableImageSelection={false}
        />

        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={closeLightbox}>
              <Carousel
                currentIndex={currentImage}
                views={photos.map(x => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.caption
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </Content>
    </div>
  );
};

export default Works;
